import React from 'react'

const NotToDate = () => {
  return (
    <div className='p-3 mt-1 duration-150'>
      <p className='flex gap-2 bg-[#2E2E2E] duration-150 p-3 rounded-md tracking-wide font-semibold'>
        <span className='animate-pulse'>📢 〈주의〉</span>
        <span className='animate-pulse'>당일 날짜 조회가 아닙니다</span>
      </p>
    </div>
  )
}

export default NotToDate